<template>
  <keep-alive>
    <ValidationProvider tag="div"
                        :bails="false"
                        :rules="rules"
                        :name="name || $attrs.label"
                        :vid="vid"
                        v-slot="{ errors, valid, required }">
      <v-text-field outlined
                    hide-details="auto"
                    v-model="innerValue"
                    :type="type"
                    :error-messages="errors"
                    :success="valid"
                    :prepend-inner-icon="prefix"
                    v-bind="$attrs"
                    v-on="$listeners">
        <template v-slot:append>
          <v-icon v-if="required">mdi-asterisk</v-icon>
        </template>
      </v-text-field>
    </ValidationProvider>
  </keep-alive>
</template>
<script>
  import { ValidationProvider } from 'vee-validate';
  import tfbHelperMixin from '@/mixins/helpers';

  export default {
    name: 'TextInput',
    mixins: [tfbHelperMixin],
    components: {
      ValidationProvider,
    },
    props: {
      vid: {
        type: String,
        default: undefined,
      },
      name: {
        type: String,
        default: undefined,
      },
      rules: {
        type: [Object, String],
        default: '',
      },
      prefix: {
        type: String,
        default: '',
      },
      type: {
        type: String,
        default: 'text',
        validator(value) {
          return [
            'url',
            'text',
            'password',
            'tel',
            'search',
            'number',
            'email',
          ].includes(value);
        },
      },
      value: {
        type: null,
      },
    },
    data() {
      return {
        innerValue: '',
      };
    },
    watch: {
      // Handles internal model changes.
      innerValue(value) {
        this.$emit('input', value);
        // this.$emit('change', value);
      },
      // Handles external model changes.
      value(newVal) {
        this.innerValue = newVal;
      },
    },
    created() {
      if (this.value) {
        this.innerValue = this.value;
      }
    },
  };
</script>
